<template>
  <div id="entropy" class="on-china-entropy">
    <!-- S 企业简介 -->
    <div
      class="company-profile"
      :style="{ height: isMore ? ($theme ? '1073px' : '1273px') : '700px' }"
    >
      <el-carousel
        class="company-profile-carousel"
        height="700px"
        :autoplay="false"
        arrow="never"
      >
        <el-carousel-item>
          <img
            src="../../../static/image/on-china-entropy/reception1.png"
            alt
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="../../../static/image/on-china-entropy/reception2.png"
            alt
          />
        </el-carousel-item>
        <el-carousel-item>
          <img
            src="../../../static/image/on-china-entropy/reception3.png"
            alt
          />
        </el-carousel-item>
      </el-carousel>
      <div class="company-profile-text">
        <div class="content content1" v-show="!isMore">
          <p class="title">{{ $theme ? "汉熵通信" : "AIoT Entropy" }}</p>
          <p v-if="$theme" class="text">
            汉熵通信有限公司（AIoT Entropy Co.,
            Ltd.简称：汉熵通信）是基于自主知识产权多模异构承载网络及边缘计算的AIoT解决方案提供商和运营商。汉熵通信致力于应用先进的射频芯片（RF）、人工智能物联网（AIoT）和数据技术激活传统工业过程。汉熵通信紧密结合重点行业需求，凭借多模异构承载网络实现“智能互联”，结合以“数据湖”技术为依托的数字底座，在物理层、数据层等多层面整合，打破“行业烟囱”及“数据孤岛”，覆盖环境生态、城市治理、应急安全等众多行业领域。汉熵通信以基于自主核心专利开发的双核感知通信终端及基站、多模异构承载网络、即时联动控制的边缘计算和行业AIoT算法，填补国家“卡脖子”关键技术空白。
          </p>
          <p v-else class="text eng">
            AIoT Entropy Co., LTD., AIoT Entropy Communication Ltd. (hereinafter
            referred to as: AIoT Entropy Communication) is the world's first
            AIoT solution provider and operator based on independent
            intellectual property rights multi-mode heterogeneous bearer network
            and edge computing. AIoT Entropy Communications is committed to
            activating traditional industrial processes by applying advanced
            radio frequency chips (RF), artificial Intelligence Internet of
            Things (AIoT) and data technologies. AIoT Entropy Communication
            closely combines the needs of key industries, realizes "intelligent
            interconnection" with multi-mode heterogeneous bearer network,
            combines with the digital base based on "data lake" technology,
            integrates at multiple levels such as physical layer and data layer,
            breaks the "industry chimney" and "data island", and covers many
            industry fields such as environmental ecology, urban governance,
            emergency safety and so on. With dual-core sensing communication
            terminals and base stations developed based on independent core
            patents, multi-mode heterogeneous bearer networks, edge computing
            and industry AIoT algorithm for real-time linkage control, AIoT
            Entropy Communication fills the key technology gaps of the national
            j "jam neck".
          </p>
          <div :class="`more`" @click="showMore" v-show="!isMore">
            <!--            <img-->
            <!--                src="@/assets/img/on-china-entropy/down.png"-->
            <!--                alt-->
            <!--            />-->
            <div class="quan">
              <div class="con">
                <i class="el-icon-right"></i>
                <i class="el-icon-right"></i>
              </div>
            </div>
            {{ $theme ? "阅读更多" : "more" }}
          </div>
        </div>
        <div class="content content2" v-show="isMore">
          <p class="title">{{ $theme ? "汉熵通信" : "AIoT Entropy" }}</p>
          <div v-if="$theme" class="text">
            <p>
              汉熵通信有限公司（AIoT Entropy Co.,
              Ltd.简称：汉熵通信）是基于自主知识产权多模异构承载网络及边缘计算的AIoT解决方案提供商和运营商。
            </p>
            <p>
              汉熵通信致力于应用先进的射频芯片（RF）、人工智能物联网（AIoT）和数据技术激活传统工业过程。汉熵通信紧密结合重点行业需求，凭借多模异构承载网络实现“智能互联”，结合以“数据湖”技术为依托的数字底座，在物理层、数据层等多层面整合，打破“行业烟囱”及“数据孤岛”，覆盖环境生态、城市治理、应急安全等众多行业领域。汉熵通信以基于自主核心专利开发的双核感知通信终端及基站、多模异构承载网络、即时联动控制的边缘计算和行业AIoT算法，填补国家“卡脖子”关键技术空白。
            </p>
            <p>
              汉熵通信设计并实施了基于多模异构承载网络及边缘计算的人工智能工业物联网，为2022冬奥会提供物联网和大数据底座支撑，并以此为基础实施了智慧环保、智慧森防、智慧城市管理、智慧公安等多行业的多个项目，解决行业痛点，引领行业发展方向，打造行业标杆，保障冬奥“蓝天白云”、“绿水青山”和城市安全，践行“科技冬奥”，向全世界展示中国人的自主研发科技实力；部分项目已被列为国家工信部物联网示范项目。
            </p>
            <p>
              汉熵通信的“基于多模异构承载网络及边缘计算的人工智能工业物联网技术及应用”发明专利获得2021年度中国发明创业奖-创新奖一等奖；发明专利
              “Multimode Heterogeneous IoT
              Networks（多模异构IoT网络）”获得2022年日内瓦国际发明奖（Inventions
              of Geneva）最高奖金奖。
            </p>
            <p>
              公司创始人王铁军博士于美国哥伦比亚大学（Columbia
              University）获无线通信专业硕士学位；于美国加州大学（圣地亚哥）（University
              of California, San
              Diego）无线通信中心获博士学位。王铁军先后师从于Dr. Richard D.
              Gitlin （贝尔实验室技术总监、美国工程院院士、IEEE终身院士），Dr.
              John G.
              Proakis（数字通信的奠基者和学术领袖、IEEE终身院士），曾荣获2006年世界IEEE
              PIMRC最佳论文奖。
            </p>
            <p>
              王铁军曾于世界知名的射频芯片设计、制造公司 RF Micro Devices, Inc.
              （RFMD）领导技术和策略发展；曾任爱立信（Ericsson）通信有限公司东北亚区（大中国区、日本、韩国）高级副总裁兼行业与企业事业部总裁。王铁军分别入选国家高层次人才特殊支持计划、国家特聘专家、国家开发银行特聘专家、中关村高端领军人才和武汉大学客座教授、北京理工大学兼职教授及博士生导师。
            </p>
            <p>
              王铁军及团队拥有六十余项已批准授权的发明专利，其中80%的专利已授权世界500强企业有偿使用，包括eBay、三星、HTC、LG、Resideo（霍尼韦尔的物联网公司）等行业顶尖国际巨头，是知识产权发展中维权成功的范例，为世界科技进步和经济发展作出了巨大贡献。汉熵通信掌握硬核自主知识产权，已实现端到端整体解决方案的落地转化，并基于专利体系的搭建及专利维权的成功经验，利用自主标准必要专利（SEP）布局行业标准，形成保护。
            </p>
            <p>
              Dr. Gitlin、Dr. Proakis 和 Dr. David
              Lyon（蓝牙标准的奠基人、第一枚蓝牙SoC芯片设计者）这三位世界殿堂级的科学家作为技术顾问，为汉熵通信的学术和技术发展提供了强有力的支撑；公司骨干成员也多来自爱立信、高通、IBM等行业巨头，具有丰富的芯片、通信设备开发经验和人工智能、大数据研发经验，人均拥有10余年的设计、研发和实际落地经验，曾主导参与过百余项国内外大型移动通信工程、智慧化项目的设计和实施。
            </p>
            <p>
              汉熵通信一直秉承“知者不惑、仁者不忧、勇者不惧”的企业文化，汇集了一群有着爱国情怀，有着科技强国梦想的行业精英，真正“用前瞻眼光构想，用科研态度做事，用实际行动强国”，脚踏实地进行核心技术开发，在自主知识产权的道路上坚定不移地走下去，为践行国家网络强国、大数据强国战略贡献力量。
            </p>
          </div>
          <div v-else class="text" style="margin-top: 40px; line-height: 29px">
            <p>
              AIoT Entropy Co., Ltd. AIoT Entropy Communication (hereinafter
              referred to as: AIoT Entropy Communication) is the world's first
              AIoT solution provider and operator based on independent
              intellectual property rights multi-mode heterogeneous bearer
              network and edge computing.
            </p>
            <p>
              AIoT Entropy Communications is committed to activating traditional
              industrial processes by applying advanced radio frequency chips
              (RF), artificial Intelligence Internet of Things (AIoT) and data
              technologies. AIoT Entropy Communication closely combines the
              needs of key industries, realizes "intelligent interconnection"
              with multi-mode heterogeneous bearer network, combines with the
              digital base based on "data lake" technology, integrates at
              multiple levels such as physical layer and data layer, breaks the
              "industry chimney" and "data island", and covers many industry
              fields such as environmental ecology, urban governance, emergency
              safety and so on. With dual-core sensing communication terminals
              and base stations developed based on independent core patents,
              multi-mode heterogeneous bearer networks, edge computing and
              industry AIoT algorithm for real-time linkage control, AIoT
              Entropy Communication fills the key technology gaps of the
              national "jam neck".
            </p>
            <p>
              AIoT Entropy Communication designed and implemented the country's
              first artificial intelligence industrial Internet of Things based
              on multi-mode heterogeneous bearer network and edge computing,
              providing Internet of Things and big data base support for the
              2022 Winter Olympics, and on this basis implemented a number of
              projects in multiple industries such as smart environmental
              protection, smart security, smart city management, and smart
              public security, solving the industry pain points and leading the
              development direction of the industry. Create industry benchmarks,
              ensure the "blue sky and white clouds", "green water and green
              mountains" and urban safety of the Winter Olympics, practice the
              "Science and Technology Winter Olympics", and show the world the
              independent research and development of Chinese science and
              technology strength; Some projects have been listed as IoT
              demonstration projects of the National Ministry of Industry and
              Information Technology.
            </p>
            <p>
              AIoT Entropy Communication's invention patent of "Artificial
              Intelligence Industrial Internet of Things Technology and
              Application Based on Multi-mode heterogeneous bearer Network and
              edge Computing" won the first prize of China Invention Innovation
              Award in 2021. The invention patent "Multimode Heterogeneous IoT
              Networks" won the highest prize award of the 2022 International
              Invention of Geneva.
            </p>
            <p>
              Dr. Tiejun Wang, the founder of the company, received a master's
              degree in wireless communication from Columbia University. He
              received his Ph.D. from the Center for Wireless Communications at
              the University of California, San Diego. Wang Tiejun has studied
              under Dr. Richard D. Gitlin (Bell LABS Technical Director,
              American Academy of Engineering, IEEE lifetime fellow), Dr. John
              G. Proakis (digital communications founder and academic leader,
              IEEE lifetime fellow), He was awarded the IEEE PIMRC Best Paper
              Award in 2006.
            </p>
            <p>
              Mr. Wang led technology and strategy development at RF Micro
              Devices, Inc. (RFMD), the world's largest RF chip design and
              manufacturing company. Previously, he was Senior Vice President
              and President of Industry & Enterprise Group, Northeast Asia
              (Greater China, Japan, Korea) of Ericsson Communications Co., LTD.
              Wang Tiejun was selected as the National Special Support Program
              for High-level Talents, National Special Expert, China Development
              Bank Special expert, Zhongguancun high-end leading talents,
              visiting professor of Wuhan University, adjunct professor and
              doctoral supervisor of Beijing Institute of Technology.
            </p>
            <p>
              Wang Tiejun and his team have more than 60 approved and authorized
              invention patents, 80% of which have been authorized for paid use
              by the world's top 500 enterprises, including eBay, Samsung, HTC,
              LG, Resideo (Honeywell's Internet of Things company) and other top
              international giants in the industry, which is a successful
              example of rights protection in the development of intellectual
              property rights. It has made great contributions to the world's
              scientific and technological progress and economic development.
              AIoT Entropy Communication has mastered the core independent
              intellectual property rights, has realized the end-to-end overall
              solution landing transformation, and based on the successful
              experience of the construction of the patent system and patent
              rights protection, the use of independent standard Essential
              patents (SEP) layout industry standards to form protection.
            </p>
            <p>
              Three world-renowned scientists, Dr. Gitlin, Dr. Proakis and Dr.
              David Lyon (founder of the Bluetooth standard and designer of the
              first Bluetooth SoC chip), serve as technical advisors to provide
              strong support for the academic and technical development of AIoT
              Entropy communication. The backbone members of the company are
              also mostly from Ericsson, Qualcomm, IBM and other industry
              giants, with rich experience in chip, communication equipment
              development and artificial intelligence, big data research and
              development experience, per capita has more than 10 years of
              design, research and development and actual landing experience,
              and has led and participated in the design and implementation of
              more than 100 domestic and foreign large-scale mobile
              communication projects and intelligent projects.
            </p>
            <p>
              AIoT Entropy Communication has been adhering to the corporate
              culture of "the wise are not confused, the benevolence is not
              worried, the brave are not afraid", bringing together a group of
              industry elites with patriotic feelings and the dream of science
              and technology power, truly "with forward-looking vision, with
              scientific research attitude, with practical action to power",
              down-to-earth core technology development, unswergingly go on the
              road of independent intellectual property rights. To contribute to
              the implementation of the national network power, big data power
              strategy.
            </p>
          </div>
          <p class="fold" @click="isMore = false">
            {{ $theme ? "收起" : "close" }}
          </p>
        </div>
      </div>
    </div>
    <!--    <div class="video-wrap">-->
    <!--      src="http://106.112.143.254:8333/chinaentropy-website/china-entropy.mp4"-->
    <video
      :src="$theme ? '/video/cn.mp4' : '/video/eng.mp4'"
      controls
      :autoplay="true"
      muted
      poster="@/assets/img/on-china-entropy/default.png"
      :style="{ width: percent + '%' }"
    ></video>
    <!--    </div>-->
    <!-- S 创始人 -->
    <div class="founder">
      <div class="title">{{ $theme ? "创始人" : "FOUNDER" }}</div>
      <div class="founder-container">
        <div class="scroll-container"></div>
        <div class="scroll-container2"></div>
        <!--        <div class="right">-->
        <!--          <div v-if="currentIndex === 0" class="text-wrap">-->
        <!--            <p style="margin-top: 148px">美国加州大学(圣地亚哥)</p>-->
        <!--            <p>University of California, San Diego</p>-->
        <!--            <div class="text">无线通信专业硕士学位, 师从于Dr. Richard D. Gitlin-->
        <!--              (贝尔实验室技术总监、美国工程院院士、IEEE终身院士)-->
        <!--            </div>-->
        <!--            <p style="margin-top: 74px">美国哥伦比亚大学</p>-->
        <!--            <p>Columbia University</p>-->
        <!--            <div class="text">无线通信专业硕士学位, 师从于Dr. Richard D. Gitlin (贝尔实验室技术总监、美国工程院院士、IEEE终身院士)-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div v-else-if="currentIndex === 1" class="text-wrap">-->
        <!--            <p style="margin-top: 148px">深耕和专注通信领域</p>-->
        <!--            <div class="text">-->
        <!--              王铁军在通信领域国际最高级学术刊物上发表了多篇被业界高度关注和广泛引用的论文，荣获2006年世界IEEE-->
        <!--              PIMRC最佳论文奖。-->
        <!--            </div>-->
        <!--            <div class="text">-->
        <!--              王博士数年来持续专注于前沿通信技术的研发应用，拥有六十余项已批准授权的发明专利，其中80%的专利已授权世界500强企业有偿使用，是知识产权发展中维权成功的范例，为世界科技进步和经济发展作出巨大贡献。-->
        <!--            </div>-->
        <!--            <div class="text">-->
        <!--              王铁军曾于世界知名的射频芯片设计、制造公司 RF Micro Devices, Inc. (RFMD)领导技术和策略发展；曾任爱立信-->
        <!--              （Ericsson）东北亚区（大中国区、日本、韩国）高级副总裁，兼行业与企业事业部总裁。-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div v-else class="text-wrap">-->
        <!--            <p style="margin-top: 86px">响应国家号召</p>-->
        <!--            <div class="text">-->
        <!--              应习总书记“大力实施网络强国战略和国家大数据战略”的号召，王铁军创办汉熵通信有限公司，践行科技兴国、实业报国。汉熵通信拥有自主知识产权，集射频芯片（RF）、人工智能物联网（AIoT）和数据技术于一体，是基于自主知识产权多模异构承载网络及边缘计算的人工智能工业物联网提供商和运营商。-->
        <!--            </div>-->
        <!--            <div class="text">-->
        <!--              王铁军分别入选国家高层次人才特殊支持计划、国家特聘专家、国家开发银行特聘专家、北京市“海外高层次人才”（海聚工程）、北京市政府特聘专家、中关村高端领军人才、北京市侨联特聘专家委员会委员和武汉大学客座教授、北京理工大学兼职教授及博士生导师。-->
        <!--            </div>-->
        <!--            <div class="text">-->
        <!--              王铁军作为中国致公党党员、致公党中央科技部委员、致公党北京市科技委员会副主任、政协委员积极参政议政，为国家科技创新献计献策。-->
        <!--            </div>-->
        <!--            <div class="text">-->
        <!--              网球、滑雪、游泳、冲浪是王博士数十年热爱的体育活动。与自然搏击，挑战自我，正如他工作学习的态度，从不懈怠！-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
    <Lead></Lead>
    <Distribution :scrollTop="scrollTop"></Distribution>
    <ModelSix @toTop="backToTop"></ModelSix>
  </div>
</template>

<script>
import ModelSix from "@/views/home/components/model-six/Index.vue";
import Lead from "./components/lead/Index.vue";
import Distribution from "./components/distribution/Index.vue";

const imgs = [
  "/image/on-china-entropy/founder/1.png",
  "/image/on-china-entropy/founder/2.png",
  "/image/on-china-entropy/founder/3.png",
  "/image/on-china-entropy/founder/4.png",
  "/image/on-china-entropy/founder/5.png",
  "/image/on-china-entropy/founder/6.png",
];
const imgsEng = [
  "/image/on-china-entropy/founder/1.png",
  "/image/on-china-entropy/founder/2.png",
  "/image/on-china-entropy/founder/3.png",
  "/image/on-china-entropy/founder/7.png",
  "/image/on-china-entropy/founder/8.png",
  "/image/on-china-entropy/founder/9.png",
];
export default {
  name: "OnChinaEntropy",
  components: { Lead, ModelSix, Distribution },
  data() {
    return {
      move: 0,
      multiple: 1,
      showHeader: true,
      scrollTop: 0,
      currentIndex: 0,
      isAnimation: false,
      bool: true,
      percent: 60,
      isMore: false,
      founderText:
        "王铁军在通信领域国际最高级学术刊物上发表了多篇被业界高度关注和广泛引用的论文，荣获2006年世界IEEE PIMRC最佳论文奖。王博士数年来持续专注于前沿通信技术的研发应用，拥有六十余项已批准授权的发明专利，其中80%的专利已授权世界500强企业有偿使用，是知识产权发展中维权成功的范例，为世界科技进步和经济发展作出巨大贡献。" +
        "</br>王铁军曾于世界知名的射频芯片设计、制造公司 RF Micro Devices, Inc. (RFMD)领导技术和策略发展；曾任爱立信 （Ericsson）东北亚区（大中国区、日本、韩国）高级副总裁，兼行业与企业事业部总裁。" +
        "</br>应习总书记“大力实施网络强国战略和国家大数据战略”的号召，王铁军创办汉熵通信有限公司，践行科技兴国、实业报国。汉熵通信拥有自主知识产权，集射频芯片（RF）、人工智能物联网（AIoT）和数据技术于一体，是基于自主知识产权多模异构承载网络及边缘计算的人工智能工业物联网提供商和运营商。" +
        "</br>王铁军分别入选国家高层次人才特殊支持计划、国家特聘专家、国家开发银行特聘专家、北京市“海外高层次人才”（海聚工程）、北京市政府特聘专家、中关村高端领军人才、北京市侨联特聘专家委员会委员和武汉大学客座教授、北京理工大学兼职教授及博士生导师。" +
        "</br>王铁军作为中国致公党党员、致公党中央科技部委员、致公党北京市科技委员会副主任、政协委员积极参政议政，为国家科技创新献计献策。" +
        "</br>网球、滑雪、游泳、冲浪是王博士数十年热爱的体育活动。与自然搏击，挑战自我，正如他工作学习的态度，从不懈怠！",
    };
  },
  methods: {
    onResize() {
      const rect = document
        .getElementsByClassName("founder-container")[0]
        .getBoundingClientRect();
      this.multiple = rect.width / 1564;
      console.log("进来了", this.multiple);
      console.log(document.getElementsByClassName("founder-container"));
      document.querySelector(".founder-container").style.height =
        this.multiple * 676 + "px";
      document.querySelector(".founder").style.height =
        this.multiple * 1080 + "px";
      // document.querySelector('.scroll-container').style.height = 100 * this.multiple + '%'
      // document.querySelector('.scroll-container2').style.height = 100 * this.multiple + '%'
    },
    //公司简介展开
    showMore() {
      this.isMore = true;
    },
    getScroll() {
      const element = document.getElementById("entropy");
      if (!element) return;
      let scrollTop_ = element.scrollTop;

      // var scrollHeight = element.scrollHeight;
      // var clientHeight = element.clientHeight;

      // if (scrollTop_ + clientHeight >= scrollHeight) {
      //   // 页面已滚动到底部
      //   this.showHeader = false;
      // } else {
      //   this.showHeader = true;
      // }
      this.showHeader = scrollTop_ < 50;
      let scrollTop =
        window.pageYOffset ||
        document.getElementById("entropy").scrollTop ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.scrollTop = scrollTop;
      if (scrollTop < 300) {
        this.percent = 68.75;
      } else if (scrollTop > 600) {
        this.percent = 100;
      } else {
        this.percent = (((scrollTop - 300) * 100) / 600) * 0.3125 + 68.75;
      }
    },
    creatItem(index) {
      const scrollContainer = document.querySelector(".scroll-container");
      let imgUrl = this.$theme ? imgs[index] : imgsEng[index];
      const item = document.createElement("div");
      item.classList.add("item");
      item.innerHTML = `<img src=${imgUrl} />`;
      scrollContainer.appendChild(item);
      return item;
    },
    creatItem2(index) {
      const scrollContainer = document.querySelector(".scroll-container2");
      let imgUrl = this.$theme ? imgs[index + 3] : imgsEng[index + 3];
      const item = document.createElement("div");
      item.classList.add("item");
      item.classList.add("item2");
      item.innerHTML = `<img src=${imgUrl} />`;
      scrollContainer.appendChild(item);
      return item;
    },
    init() {
      const { currentIndex } = this;
      const scrollContainer = document.querySelector(".scroll-container");
      scrollContainer.innerHTML = "";
      let preIndex = currentIndex - 1 < 0 ? imgs.length - 1 : currentIndex - 1;
      let nextIndex = currentIndex + 1 > imgs.length - 1 ? 0 : currentIndex + 1;
      this.creatItem(preIndex).classList.add("pre");
      this.creatItem(currentIndex).classList.add("cur");
      this.creatItem(nextIndex).classList.add("next");
      const scrollContainer2 = document.querySelector(".scroll-container2");
      scrollContainer2.innerHTML = "";
      this.creatItem2(preIndex).classList.add("pre");
      this.creatItem2(currentIndex).classList.add("cur");
      this.creatItem2(nextIndex).classList.add("next");
    },
    onWheel(e) {
      const scrollContainer = document.querySelector(".scroll-container");
      const scrollContainer2 = document.querySelector(".scroll-container2");
      if (e.deltaY === 0) {
        return;
      }
      if (this.isAnimation) {
        e.preventDefault();
        return;
      }
      let { currentIndex } = this;
      this.bool = true;
      if (e.deltaY > 0) {
        //向下滚动
        if (currentIndex < 2) {
          //需求不是无限的
          e.preventDefault();
          this.isAnimation = true;
          scrollContainer.classList.add("scroll-down");
          scrollContainer2.classList.add("scroll-down");
          scrollContainer2.classList.add("scroll-down2");
          this.currentIndex++;
        } else {
          this.bool = false;
        }
      } else {
        //向上滚动
        if (currentIndex > 0) {
          e.preventDefault();
          this.isAnimation = true;
          scrollContainer.classList.add("scroll-up");
          scrollContainer2.classList.add("scroll-up");
          scrollContainer2.classList.add("scroll-up2");
          this.currentIndex--;
        } else {
          this.bool = false;
        }
      }
    },
    backToTop() {
      document
        .getElementById("entropy")
        .scrollTo({ left: 0, top: 0, behavior: "smooth" });
    },
  },
  mounted() {
    // window.addEventListener("resize", (e) => {
    //   this.onResize(e)
    // })
    const element = document.getElementById("entropy");
    element.addEventListener("scroll", this.getScroll, false);
    this.init();
    const scrollContainer = document.querySelector(".scroll-container");
    const scrollContainer2 = document.querySelector(".scroll-container2");
    scrollContainer.addEventListener(
      "wheel",
      (e) => {
        this.onWheel(e);
      },
      false
    );
    scrollContainer2.addEventListener(
      "wheel",
      (e) => {
        this.onWheel(e);
      },
      false
    );
    scrollContainer.addEventListener("transitionend", () => {
      if (!this.bool) {
        return;
      }
      this.isAnimation = false;
      scrollContainer.classList.remove("scroll-up");
      scrollContainer.classList.remove("scroll-down");
      scrollContainer2.classList.remove("scroll-up");
      scrollContainer2.classList.remove("scroll-up2");
      scrollContainer2.classList.remove("scroll-down");
      scrollContainer2.classList.remove("scroll-down2");
      this.init();
    });
    // scrollContainer2.addEventListener('transitionend2', () => {
    //   // console.log('transitionend')
    //   if (!this.bool2) {
    //     return
    //   }
    //   this.isAnimation2 = false
    //   scrollContainer2.classList.remove('scroll-up')
    //   scrollContainer2.classList.remove('scroll-down')
    //   this.init(2)
    // })
    this.$nextTick(() => {
      this.onResize();
    });
  },
  watch: {
    showHeader(val) {
      this.$bus.$emit("change-show-header", val);
    },
  },
  beforeDestroy() {
    const element = document.getElementById("entropy");
    element.removeEventListener("scroll", this.getScroll);
    window.removeEventListener("resize", (e) => {
      this.onResize(e);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "./main.scss";

.scroll-container {
  //width: 900px;
  width: 57.548%;
  height: 100%;
  position: relative;
}

.scroll-container2 {
  //width: 733px;
  width: 42.452%;
  height: 100%;
  position: relative;
}

::v-deep {
  .item {
    position: absolute;
    width: 100%;
    height: 100%;
    overflow: hidden;
    //transition: 2s ease-in-out;
    transition: 1s linear;
  }

  .item img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: cover;
    //transition: 1s ease-in-out;
    transition: 0.5s linear;
  }

  .item.pre,
  .item.next {
    z-index: 1;
    height: 0;
  }

  .item.pre {
    top: 0;
  }

  .item.next {
    bottom: 0;
  }

  .item.pre img {
    transform: translateY(-30%);
  }

  .item.next img {
    bottom: 0;
    transform: translateY(30%);
  }

  .item2.pre img {
    transform: translateY(-50%);
  }

  .item2.next img {
    bottom: 0;
    transform: translateY(50%);
  }

  .scroll-up .pre,
  .scroll-down .next {
    height: 100%;
  }

  .scroll-up .pre img {
    transform: translateY(0);
  }

  .scroll-up .cur img {
    transform: translateY(30%);
  }

  .scroll-down .next img {
    transform: translateY(0);
  }

  .scroll-down .cur img {
    transform: translateY(-30%);
  }

  .scroll-up2 .cur img {
    transform: translateY(50%);
  }

  .scroll-down2 .cur img {
    transform: translateY(-50%);
  }
}
</style>
